import * as React from "react";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from "@mui/icons-material/Close";
import Heading from "../../Atoms/heading/EventEHRHeading";
import CreateVisitForm from "./CreateVisitForm";
import EventEHRToggleButton from "../../Molecules/toggle-button/EventEHRToggleButton";
import { useDispatch } from "react-redux";
import { getIncidentLocations } from "../../../screens/patient-screen/patientSaga";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width: "708px", // Set your custom width here
    maxWidth: "none", // Prevents Material-UI from overriding your width
  },
}));

interface defaultSelectedFormDataProps {
  patientId: number;
  bsaId: string;
  firstName: string;
  lastName: string;
  unitNumber: string;
  campName: string;
  campId?: string;
}

interface EventEHRCreateVisitDialogProps {
  isOpen: boolean;
  formData?: defaultSelectedFormDataProps;
  dialogHeading: string;
  comesFrom?: string;
  handleClose: () => void;
  handleSubmittedData?: (data: any, selectedVisitType: string) => void;
  onEMSVisitSelected?: () => void;
}

export default function EventEHRCreateVisitDialog({
  isOpen = false,
  comesFrom,
  formData,
  handleSubmittedData,
  handleClose,
  dialogHeading = "Your Heading Here...",
  onEMSVisitSelected,
}: EventEHRCreateVisitDialogProps) {
  const dispatch = useDispatch();
  const headerStyle = {
    fontWeight: "500",
    fontSize: "16px",
    paddingBottom: "10px",
  };
  const [selectedVisitType, setSelectedVisitType] =
    React.useState<string>("walkIn");

  const handleToggleChange = (value: string) => {
    if (value === "ems") {
      onEMSVisitSelected?.();
      handleClose();
      setSelectedVisitType("walkIn");
      return;
    }
    setSelectedVisitType(value);
  };

  React.useEffect(() => {
    // Facilities are now lazy-loaded inside FacilitySelect, so no Redux fetch
    // is needed here. incidentLocationData is still consumed by CreateVisitForm.
    dispatch(getIncidentLocations());
  }, []);

  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
      >
        <div
          className="flex justify-between items-center"
          style={{ margin: "14px 24px" }}
        >
          <Heading title={dialogHeading} />
          <div onClick={handleClose} className="cursor-pointer">
            <CloseIcon />
          </div>
        </div>

        <DialogContent dividers style={{ padding: "16px 24px 24px 24px" }}>
          <Heading title="Visit Type" customStyle={headerStyle} />
          <EventEHRToggleButton
            onChange={handleToggleChange}
            options={[
              { value: "ems", label: "EMS Visit" },
              { value: "walkIn", label: "Walk In Visit" },
            ]}
            selectedValue={selectedVisitType}
          />
          <div className="mt-6">
            {selectedVisitType === "walkIn" && (
              <CreateVisitForm
                defaultSelectedData={formData}
                comesFrom={comesFrom}
                handleOnSubmittedData={(formData) => {
                  handleSubmittedData &&
                    handleSubmittedData(formData, selectedVisitType);
                }}
              />
            )}
          </div>
        </DialogContent>
      </BootstrapDialog>
    </React.Fragment>
  );
}
